
import { Pagination, Select } from "antd";
import React, { useState } from "react";
// import { ChevronDownPagination, ChevronUpPagination } from "../../icons";
import style from "./Pagination.module.css";
const CustomPaging = (props) => {
  const [page, setPage] = useState(props?.current > Math.ceil(props?.total / props?.pageSize) ? Math.ceil(props?.total / props?.pageSize) : props?.current);
  const [dropdownArrow, setArrow] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        background: props.background ? props.background : "#EAEAEA",
        borderTop: "2px solid #783F91",
        borderRadius: "0 0 16px 16px",
        height: "40px",
      }}
    >
      <div className="custom-props">
        <div style={{ display: "flex" }}>
          <span style={{ marginTop: "auto", marginBottom: "auto", marginLeft: 8, marginRight: 8, color: "#1A1A1A", fontWeight: 500 }}>{props.title}</span>
          <div className={props.background ? style.WrapCustom : style.WrapDefault}>
            <Select
              id={props.idLimit}
              style={{ width: 49, height:28 }}
              value={props?.pageSize ? props?.pageSize : 10}
              onChange={(value) => props.handlePaging(page, value)}
              onDropdownVisibleChange={(open) => { setArrow(open) }}
              // suffixIcon={ dropdownArrow ? <ChevronUpPagination /> : <ChevronDownPagination /> }
            >
              {props?.pageSizeOptions &&
                props?.pageSizeOptions?.map((item) => (
                  <Select.Option value={item} key={item}>
                    {item}
                  </Select.Option>
                ))}
            </Select>
          </div>
        </div>
      </div>
      <div id={props?.idPagination} className={style.Wrap}>
        <Pagination 
          {...props}
          onChange={(value)=>props.handlePaging(value, props.pageSize)} 
          />
      </div>
    </div>
  );
};

export default CustomPaging;
